<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">mdi-file</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped" id="table-epp1">
              <thead>
                <tr>
                  <th class="text-center">
                    No.
                  </th>
                  <th class="text-center">
                    TOR
                  </th>
                  <th class="text-center">
                    Name
                  </th>
                  <th class="text-center">
                    URL
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in listMenuP2" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.tor }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    {{ item.url }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ListMenuP2",
  data() {
    return {
      listMenuP2: [
        {
          tor: "TOR1",
          name: "บันทึกจำนวนรับลงทะเบียนเรียน",
          url: "/updateRegisAmount"
        },
        {
          tor: "TOR2",
          name: "ย้ายตอนเรียนในการแจ้งความประสงค์ ตามรายวิชา ",
          url: "/transferClassByCourse"
        },
        {
          tor: "TOR3",
          name: "ย้ายตอนเรียนในการแจ้งความประสงค์ ตามรายบุคคล ",
          url: "/transferClassByPerson"
        },
        {
          tor: "TOR4",
          name: "บันทึกสถานะการเปิดรับนักศึกษา",
          url: "/stuAdmissionStatusRec"
        },
        {
          tor: "TOR5",
          name: "กำหนดสิทธิ์จัดการรายวิชา (ย้ายไปผู้ประสานงาน ให้สามารถใช้เมนูนี้ได้)",
          url: "/permissionManageByCourses"
        },
        {
          tor: "TOR6",
          name: "อนุมัติการแจ้งความประสงค์ ช่วงการลงทะเบียนเรียนล่าช้า",
          url: "/appReqLateRegis"
        },
        {
          tor: "TOR7",
          name: "ตรวจสอบผลการอนุมัติแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/chkResultsApprovalReqEnroll"
        },
        {
          tor: "TOR8",
          name: "กำหนดผู้ประสานงานตารางสอนตารางสอบ ประจำ ปี/ภาค การศึกษา",
          url: "/setCoorSchedForYearSem"
        },
        {
          tor: "TOR9",
          name: "กำหนดผู้ประสานงานตารางสอนตารางสอบ ประจำ รายวิชา",
          url: "/setCoorSchedForCourse"
        },
        {
          tor: "TOR10",
          name: "กำหนดหน่วยกิตของนักศึกษาสภาพวิทยาทัณฑ์",
          url: "/setCreditStuProbation"
        },
        {
          tor: "TOR11",
          name: "กำหนดเงื่อนไขควบคุมการลงทะเบียนเรียน",
          url: "/setConditionCtrlEnroll"
        },
        {
          tor: "TOR12",
          name: "ตรวจสอบประวัติการยกเลิกเงื่อนไขควบคุมการลงทะเบียนเรียน",
          url: "/chkHConditionCancelCtrlEnroll"
        },
        {
          tor: "TOR13",
          name: "แจ้งความประสงค์ขอลงทะเบียนเรียน เป็นชุด",
          url: "/reqEnrollForSet"
        },
        {
          tor: "TOR14",
          name: "ยกเลิกการแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/cancelReqEnrollment"
        },
        {
          tor: "TOR15",
          name: "เคลียข้อมูลการแจ้งความประสงค์ลงทะเบียนได้",
          url: "/clearDataReqEnroll"
        },
        {
          tor: "TOR16",
          name: "ลงทะเบียนเรียนให้กับนักศึกษา เป็นชุด",
          url: "/regisStuForSet"
        },
        {
          tor: "TOR17",
          name: "ลงทะเบียนรายวิชาที่มีสัญลักษณ์ P",
          url: "/regisCoursesP"
        },
        {
          tor: "TOR18",
          name: "ลงทะเบียนรักษาสถานภาพ / ลาพัก",
          url: "/registrationStatusLeave"
        },
        {
          tor: "TOR19",
          name: "ยกเลิกการลงทะเบียนเรียนตามรายบุคคล",
          url: "/cancelindividualEnroll"
        },
        {
          tor: "TOR20",
          name: "ยกเลิกการลงทะเบียนเรียนตามรายวิชา",
          url: "/cancelRegisByCourse"
        },
        {
          tor: "TOR21",
          name:
            "เจ้าหน้าที่สามารถตรวจสอบ log ในการแจ้งความประสงค์และในการลงทะเบียนเรียนได้",
          url: "/logStudent"
        },
        {
          tor: "TOR22.1",
          name:
            "เจ้าหน้าที่สามารถตรวจสอบผลการแจ้งความประสงค์ขอลงทะเบียนเรียนเป็นรายบุคคลหรือเป็นชุดได้",
          url: "/rpterpreenroll"
        },
        {
          tor: "TOR22.2",
          name:
            "เจ้าหน้าที่สามารถตรวจสอบผลการแจ้งความประสงค์ขอลงทะเบียนเรียนตามรายวิชา",
          url: "/rpterpreenrollbyco"
        },
        {
          tor: "TOR22.3",
          name:
            "เจ้าหน้าที่สามารถตรวจสอบผลการแจ้งความประสงค์ขอลงทะเบียนเรียนตามอาจารย์ที่ปรึกษา",
          url: "/rpterpreenrollbyinst"
        },
        {
          tor: "TOR22.4",
          name:
            "ตรวจสอบรายชื่อนักศึกษาที่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามอาจารย์ที่ปรึกษา",
          url: "/rpterconfirmbyinst"
        },
        {
          tor: "TOR22.5",
          name:
            "สรุปจำนวนที่เปิดรับเปรียบเทียบกับจำนวนนักศึกษาที่แจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/rpterprebyenroll"
        },
        {
          tor: "TOR22.6",
          name:
            "รายชื่อนักศึกษาที่แจ้งความประสงค์เกิน 9 หน่วยกิต แต่ได้รับอนุมัติต่ำกว่า 9 หน่วยกิต",
          url: "/rpterstudentless9"
        },
        {
          tor: "TOR22.7",
          name:
            "รายชื่อนักศึกษาที่ลงทะเบียนรายวิชาที่ไม่มีในโครงสร้างหลักสูตร",
          url: "/rpterenrolloutprogram"
        },
        {
          tor: "TOR22.8",
          name:
            "รายชื่อนักศึกษาที่ลงทะเบียนล่าช้าพร้อมค่าปรับ",
          url: "/rpterenrolllatefine"
        },
        {
          tor: "TOR22.9",
          name:
            "รายชื่อนักศึกษาที่ยังไม่มาทำการลงทะเบียนเรียน",
          url: "/rpterstdnotenroll"
        },
        {
          tor: "TOR22.10",
          name: "จำนวนนักศึกษาที่ยังไม่มาทำการลงทะเบียนเรียน",
          url: "/rpterctstdnotenroll"
        },
        {
          tor: "TOR22.11",
          name:
            "รายชื่อนักศึกษาที่ไม่ชำระค่าธรรมเนียมการศึกษา",
          url: "/rpterstdnotpaid"
        },
        {
          tor: "TOR22.12",
          name: "จำนวนนักศึกษาที่ไม่ชำระค่าธรรมเนียมการศึกษา",
          url: "/rpterctstdnotpaid"
        },
        {
          tor: "TOR22.13",
          name:
            "รายชื่อนักศึกษาที่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา ",
          url: "/rpterstdconfirmbyco"
        },
        {
          tor: "TOR22.14",
          name: "จำนวนนักศึกษาที่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา",
          url: "/rpterctstdconfirmbyco"
        },
        {
          tor: "TOR22.15",
          name: "รายชื่อนักศึกษาที่ไม่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา",
          url: "/rpterstdnotconfirmbyco"
        },
        {
          tor: "TOR22.16",
          name: "จำนวนนักศึกษาที่ไม่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา",
          url: "/rpterctstdnotconfirmbyco"
        },
        {
          tor: "TOR22.17",
          name: "รายชื่อนักศึกษาที่ยืนยันแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/rpterstdapprove"
        },
        {
          tor: "TOR22.18",
          name: "จำนวนนักศึกษาที่ยืนยันแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/rpterctstdapprove"
        },
        {
          tor: "TOR22.19",
          name: "รายชื่อนักศึกษาที่ไม่ได้แจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/rpterstdnotpreenroll"
        },
        {
          tor: "TOR22.20",
          name: "จำนวนนักศึกษาที่ไม่ได้แจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/rpterctstdnotpreenroll"
        },
        {
          tor: "TOR22.21",
          name: "รายชื่อนักศึกษาที่ลงทะเบียนเรียนโดยมีตารางสอบซ้ำซ้อน",
          url: "/rpterstdexam"
        },
        {
          tor: "TOR22.22",
          name: "จำนวนนักศึกษาที่ลงทะเบียนเรียนโดยมีตารางสอบซ้ำซ้อน",
          url: "/rpterctstdexam"
        },
        {
          tor: "TOR22.23",
          name: "รายชื่อนักศึกษาที่แจ้งความประสงค์ขอลงทะเบียนเรียนแต่ยังไม่ยืนยัน",
          url: "/rpterstdprenotconfirm"
        },
        {
          tor: "TOR22.24",
          name: "จำนวนนักศึกษาที่แจ้งความประสงค์ขอลงทะเบียนเรียนแต่ยังไม่ยืนยัน",
          url: "/rpterctstdprenotconfirm"
        },
        {
          tor: "TOR22.25",
          name: "รายชื่อนักศึกษาที่ลงทะเบียนรักษาสถานภาพ / ลาพัก ",
          url: "/rpterstdstatusmaintain"
        },
        {
          tor: "TOR22.26",
          name: "จำนวนนักศึกษาที่ลงทะเบียนรักษาสถานภาพ / ลาพัก",
          url: "/rpterctstdstatusmaintain"
        }
      ]
    };
  }
};
</script>
